<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import forgotPasswordFormJson from '@/data/json/homepage/forgotPasswordForm.json'
import errorsJson from '@/data/json/errors/errors.json'
import validationsJson from '@/data/json/errors/validations.json'

export default {
  mixins: [validationMixin],
  validations: {
    email: { required, email }
  },
  data: () => ({
    content: forgotPasswordFormJson.data.concat(
      errorsJson.data,
      validationsJson.data
    ),
    email: ''
  }),
  computed: {
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email &&
      errors.push(this.$t('validation.email.invalid'))
      !this.$v.email.required &&
      errors.push(this.$t('validation.email.required'))
      return errors
    }
  },
  methods: {
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$notify(this.$t('validation.form.incomplete'), { type: 'error' })
        return
      }

      return this.$userService
        .sendPasswordResetEmail({
          email: this.email,
          passwordResetURL: `${window.config.VUE_APP_BASE_URL}/resetpassword`
        })
        .then(() => {
          this.$notify(this.$t('page.forgotPasswordForm.email.success'), {
            type: 'success'
          })
        })
        .catch(e => {
          const msg = e.fromCms
            ? e.message
            : this.$cmsService.getContent(this.content, e.response.status)
          this.$notify(msg, { type: 'error' })
        })
    }
  }
}
</script>
<template>
  <v-card>
    <DialogBaseColoredTitle color="primary">
      {{ $t('page.forgotPasswordForm.header') }}</DialogBaseColoredTitle
    >
    <DialogBaseCloseIcon color="white" @click="$emit('close')" />
    <v-divider></v-divider>
    <DialogBaseText class="text-center primary--text">
      <v-row>
        <v-col> {{ $t('page.forgotPasswordForm.subheader') }} </v-col>
      </v-row>
    </DialogBaseText>
    <DialogBaseText class="text-center">
      <v-text-field
        id="email"
        v-model="email"
        class="cms_eMail"
        :label="$t('page.forgotPasswordForm.email.label')"
        :error-messages="emailErrors"
        outlined
        dense
        required
        @input="$v.email.$touch()"
        @keyup.enter.native="submit()"
      ></v-text-field>
    </DialogBaseText>
    <v-divider></v-divider>
    <DialogBaseActions>
      <v-row class="ma-0">
        <v-col>
          <v-btn
            id="passwordForgotSubmit"
            class="text-center px-8"
            color="primary"
            dark
            depressed
            @click.stop="submit"
            >{{ $t('button.request.new.password') }}</v-btn
          >
        </v-col>
      </v-row>
    </DialogBaseActions>
  </v-card>
</template>